import { useEffect, useState } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useEuEligible } from './useEuEligible';

import type { useExposedReturnsClientVariant_viewer$key } from './__generated__/useExposedReturnsClientVariant_viewer.graphql';

const viewerFragment = graphql`
    fragment useExposedReturnsClientVariant_viewer on Viewer {
        ...useEuEligible_viewer @arguments(userCountryCode: $userCountryCode)
        user(userId: $userId) @include(if: $fetchUser) {
            isVerifiedTrade
        }
    }
`;

export const useExposedReturnsClientVariant = ({
    viewer: viewerRef,
}: {
    viewer?: useExposedReturnsClientVariant_viewer$key | null;
}): boolean | null => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const isEuEligible = useEuEligible({ viewer });
    const isTrade = viewer?.user?.isVerifiedTrade;

    const [isExposedReturnsClientVariant, setIsExposedReturnsClientVariant] =
        useState<boolean>(false);

    useEffect(() => {
        if ((isEuEligible || isTrade) && getAbTestV2('ReturnsonPDP')?.variant === 'variant') {
            setIsExposedReturnsClientVariant(true);
        }
    }, [isEuEligible, isTrade]);

    return viewer ? isExposedReturnsClientVariant : false;
};
